
import Vue from "vue";
import Component from "vue-class-component";
import filters from "@/filters";
import { Prop } from "vue-property-decorator";
import { CourseLevelEnum, EnumHelper } from "@/constants/enum.constant";

@Component({
  components: {},
  filters,
})
export default class MyCourseItem extends Vue {
  @Prop({ default: true })
  private stats!: boolean;
  @Prop({ default: "course_item_start" })
  private textButton!: string;
  @Prop({ default: null })
  private course!: any;

  private levels = EnumHelper(CourseLevelEnum);

  private get progress() {
    return parseFloat(this.course?.progress_percentage).toFixed(2);
  }

  private detail() {
    this.$router.push({
      name: "my-course-detail",
      params: {
        slug: this.course?.slug,
      },
    });
  }
}
